"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
// eslint-disable-next-line tsdoc/syntax
/** @type {() => Promise<typeof import("pdfjs-dist/legacy/build/pdf.mjs")>} */
const getPdfjs = async () => {
    // eslint-disable-next-line tsdoc/syntax
    /** @type {() => Promise<typeof import("pdfjs-dist/legacy/build/pdf.mjs")>} */
    let pdfjs;
    try {
        pdfjs = await eval("import(\"./pdfjs/pdf.min.mjs\")");
    }
    catch {
        try {
            pdfjs = await eval("import(\"./pdfjs/pdf.mjs\")");
        }
        catch {
            try {
                pdfjs = await Promise.resolve().then(() => __importStar(require("pdfjs-dist/legacy/build/pdf.mjs")));
            }
            catch {
                pdfjs = await eval("import(\"pdfjs-dist/legacy/build/pdf.mjs\")");
            }
        }
    }
    try {
        void await eval("import(\"./pdfjs/pdf.worker.min.mjs\")");
        pdfjs.GlobalWorkerOptions.workerSrc = "./pdf.worker.min.mjs";
    }
    catch {
        try {
            void await eval("import(\"./pdfjs/pdf.worker.mjs\")");
        }
        catch {
            try {
                void await eval("import(\"pdfjs-dist/legacy/build/pdf.worker.mjs\")");
            }
            catch {
                pdfjs.GlobalWorkerOptions.workerSrc = "../core/node_modules/pdfjs-dist/legacy/build/pdf.worker.mjs";
            }
        }
    }
    return pdfjs;
};
exports.getPdfjs = getPdfjs;
//# sourceMappingURL=getPdfjs.js.map